import { useAuthSelector } from 'app/data/auth';
import callsQueryKeys from 'app/hooks/queries/calls/callsQueryKeys';
import { sdk } from 'app/sdk';
import { useQuery } from 'react-query';
import { CallsParkedPageResponse } from 'types/calls';

export const useCallsParkedQuery = (
  skip: number,
  take: number,
  orderBy: any,
  filters: any,
) => {
  // returns list of callflows
  // - just get ALL callflows+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = callsQueryKeys.parked(skip, take, orderBy, filters);

  const query = useQuery<CallsParkedPageResponse, Error>(
    queryKey,
    () =>
      sdk.calls.query.parked(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useCallsParkedQuery;
